export const UPDATES_ROOM_NAME = "subscribeUpdates";
export const BULK_ACTIONS_UPDATE_EVENT_NAME = "BULK_EDIT_STATUS_UPDATE";
export const REVOKE_PERMISSIONS_STATUS_UPDATE_EVENT = "REVOKE_PERMISSIONS_STATUS_UPDATE";
